import { Tabs, TabsProps } from 'antd';
import { NotifyUseCaseInterface } from 'application/usecases/NotifyUseCase';
import { PageTitle } from 'presentation/components/PageTitle';
import Tab1Component from './tab1';
import Tab2Component from './tab2';
interface props {
    notifyUseCase: NotifyUseCaseInterface;
}

const CU02201Page = ({ notifyUseCase }: props) => {
    const TabInfomation: TabsProps['items'] = [
        {
            label: '運営お知らせ',
            key: '1',
            children: <Tab1Component notifyUseCase={notifyUseCase} />,
        },
        {
            label: 'システム通知',
            key: '2',
            children: <Tab2Component notifyUseCase={notifyUseCase} />,
        },
    ];

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                textAlign: 'center',
            }}
            className="CU-022-01-container"
        >
            <section>
                <PageTitle title="お知らせ一覧" />
            </section>

            <Tabs
                defaultActiveKey="1"
                className="tab-dashboard-title-container"
                items={TabInfomation}
            />
        </div>
    );
};

export default CU02201Page;
